import { apiClient } from "@/lib/api/client";
import type { CapabilitiesDto } from "@/features/capabilities/types";

/**
 * Merr flags te strukturuara te moduleve per AppShell.
 */
export const getCapabilities = async (): Promise<CapabilitiesDto> => {
  const response = await apiClient.get<CapabilitiesDto>("/capabilities");

  return response.data;
};
